import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Alert } from 'react-bootstrap';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { Table } from '@rd-web-markets/shared/dist/util';
import { CheckboxCell } from '@rd-web-markets/shared/dist/util/Table/CheckboxCell';
import { InputCell } from '@rd-web-markets/shared/dist/util/Table/InputCell';
import { DeleteButton, SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import competentProfessionalsService from '../../services/company/competent_professional.service';
export default function CompetentProfessionalTable(_ref) {
  let {
    competentProfessionals,
    setcompetentProfessionals,
    createcompetentProfessional,
    updatecompetentProfessional,
    onSort,
    headers,
    onFilter
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    id: companyId
  } = useParams();
  const dispatch = useDispatch();
  const [duplicates, setDuplicates] = useState([]);
  useEffect(() => {
    if (!competentProfessionals) return;
    const emails = competentProfessionals.map(a => a.email);
    const count = emails => emails.reduce((result, value) => ({
      ...result,
      [value]: (result[value] || 0) + 1
    }), {});
    const duplicates = dict => Object.keys(dict).filter(a => dict[a] > 1);
    setDuplicates(duplicates(count(emails)).filter(e => e !== '').filter(e => e !== null).filter(e => e !== undefined).filter(e => e !== 'null'));
  }, [competentProfessionals]);
  const updatecompetentProfessionalFromState = useCallback((name, value, body) => {
    const indexInState = competentProfessionals.findIndex(r => r.id === body.id);
    competentProfessionals[indexInState][name] = value;
    competentProfessionals.splice(indexInState, 1, body);
    setcompetentProfessionals([...competentProfessionals]);
  }, [competentProfessionals, setcompetentProfessionals]);
  const updateChanges = useCallback(async competentProfessional => {
    await updatecompetentProfessional({
      ...competentProfessional
    });
  }, [updatecompetentProfessional]);
  const createNew = useCallback(async competentProfessional => {
    await createcompetentProfessional({
      ...competentProfessional
    });
  }, [createcompetentProfessional]);
  if (!competentProfessionals) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  const emptycompetentProfessional = {
    id: 'new_res',
    name: '',
    phone: '',
    qualifications: '',
    relevant_experience: '',
    email: '',
    has_advance_access: false
  };
  const addNewcompetentProfessionalRow = () => {
    setcompetentProfessionals([{
      ...emptycompetentProfessional,
      id: `new_res-${Math.round(Math.random() * 1000)}`
    }, ...competentProfessionals]);
  };
  const deletecompetentProfessional = async competentProfessional => {
    if (window.confirm(`Are you sure you want to delete the Competent Professional ${competentProfessional.name}`)) {
      try {
        await competentProfessionalsService.delete(companyId, competentProfessional.id);
        setcompetentProfessionals(competentProfessionals.filter(r => r.id !== competentProfessional.id));
      } catch (e) {
        dispatch(handleError(e));
      }
    }
  };
  const buildRows = () => {
    const rows = competentProfessionals.map((competentProfessional, index) => {
      const saveProgram = competentProfessional => {
        if (typeof competentProfessional.id === 'string' && competentProfessional.id.includes('new_res')) {
          createNew(competentProfessional);
        } else {
          updateChanges(competentProfessional);
        }
      };
      return {
        data: {
          competentProfessional: competentProfessional
        },
        key: competentProfessional.id,
        columns: [/*#__PURE__*/React.createElement(InputCell, {
          body: competentProfessional,
          value: competentProfessional.name,
          fieldName: "name",
          onBlur: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(InputCell, {
          body: competentProfessional,
          value: competentProfessional.qualifications,
          fieldName: "qualifications",
          onBlur: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(InputCell, {
          body: competentProfessional,
          value: competentProfessional.relevant_experience,
          fieldName: "relevant_experience",
          onBlur: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(InputCell, {
          body: competentProfessional,
          value: competentProfessional.email,
          fieldName: "email",
          onBlur: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(InputCell, {
          body: competentProfessional,
          value: competentProfessional.phone,
          fieldName: "phone",
          onBlur: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(CheckboxCell, {
          body: competentProfessional,
          value: competentProfessional.has_advance_access,
          fieldName: "has_advance_access",
          onChange: updatecompetentProfessionalFromState
        }), /*#__PURE__*/React.createElement(DeleteButton, {
          onClick: () => deletecompetentProfessional(competentProfessional)
        }), /*#__PURE__*/React.createElement(SaveButton, {
          onClick: () => saveProgram(competentProfessional)
        })]
      };
    });
    return rows;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, duplicates.length > 0 && /*#__PURE__*/React.createElement(Alert, {
    variant: "danger"
  }, "Be careful you have created Competent Professionals with the same e-mail address ", duplicates.join(', ')), /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'auto',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React.createElement("style", null, `
              .competentProfessionals-Tab-table-header {
                word-break: break-word;
              }
            `), /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: buildRows(),
    onFilter: onFilter,
    textFilterQueryStringParamName: "query",
    onSort: onSort,
    opts: {
      headerClass: 'competentProfessionals-Tab-table-header'
    },
    onAddRow: addNewcompetentProfessionalRow,
    addRowTextKey: "add_competentProfessional",
    displayAddRowBelow: false
  }))));
}